import Toaster from "../utils/classes/Toaster";

export default function(el) {
    const text = el.dataset.text;

    const handleClick = () => {
        const toast = Toaster.createToast("text-copy", "URL copied to clipboard");
        Toaster.renderToast(toast);
        navigator.clipboard.writeText(text);
    };

    if (!text) return;

    el.addEventListener("click", handleClick);
}
